import Vue from 'vue'

function extractError(response) {
    return "Error: " + response.status + " (" + response.url + "): " + JSON.stringify(response.data);
}

var baseUrl = ""
if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://kepler.playcar.net/api/backoffice/v1/';
} else {
  baseUrl = 'https://core.staging.playmoove.com:8585/api/backoffice/v1/';
}

const KeplerSdk = {
    user: {
        profile: null
    },
    login: function (username, password, successCallback, errorCallback) {
        Vue.http.post(baseUrl + 'login', {
            username: username,
            password: password
        }).then((response) => {
            localStorage.setItem('token', response.data.token)
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        });
    },
    lastReservation: function (successCallback, errorCallback) {
        Vue.http.get(baseUrl + 'driver/last_reservation', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(extractError(response))
        });
    },
    extendReservation: function (body, successCallback, errorCallback) {
        Vue.http.patch(baseUrl + 'reservation/extend', body, {headers: this.getAuthHeader()})
            .then((response) => {
                successCallback(response.data)
            }, (response) => {
                errorCallback(extractError(response))
            })
    },
    reservationList: function (successCallback, errorCallback) {
        return Vue.http.get(baseUrl + 'reservation/list', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(extractError(response))
        });
    },
    paymentMethodsList: function (successCallback, errorCallback) {
        return Vue.http.get(baseUrl + 'payment_methods', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(extractError(response))
        });
    },
    createPaymentMethod: function (body, successCallback, errorCallback) {
        Vue.http.post(baseUrl + 'payment_methods/add_by_info', body, {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    subscriptionList: function (successCallback, errorCallback) {
        Vue.http.get(baseUrl + 'subscriptions/available_subscriptions', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(extractError(response))
        });
    },
    purchaseSubscription: function (subscriptionId, successCallback, errorCallback) {
        Vue.http.post(baseUrl + 'subscription/subscribe', {
            plan_id: subscriptionId
        }, {headers: this.getAuthHeader()})
            .then((response) => {
                successCallback(response.data)
            }, (response) => {
                errorCallback(response.data)
            })
    },
    getAuthHeader() {
        return {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    },
    isUserAuthenticated(){
        return localStorage.getItem('token') != null
    },
    register(body, successCallback, errorCallback){
        Vue.http.post(baseUrl + 'client/register', body)
            .then((response) => {
                successCallback(response.data)
            }, (response) => {
                errorCallback(response.data)
            })
    },
    getClientTypes(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'client/types').then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    getDriverLicense(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'license/types')
            .then((response) => {
                successCallback(response.data)
            }, (response) => {
                errorCallback(response.data)
            })
    },
    fleetSearch(start, end, booking_mode, vehicle_category_id, successCallback, errorCallback){
        Vue.http.get(baseUrl + 'fleet/advanced_search?' + 'start=' + start + '&end=' + end + '&booking_mode=' + booking_mode + '&vehicle_category_id=' + vehicle_category_id
            , {
                headers: this.getAuthHeader()
            }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    vehicleCatetoriesSearch(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'fleet/categories', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    bookReservation(body, successCallback, errorCallback){
        Vue.http.post(baseUrl + 'reservation/book', body, {

            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    currentReservation(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'reservation/current', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    openCar(){
        Vue.http.post(baseUrl + 'reservation/open', null, {
            headers: this.getAuthHeader()
        })
    },
    closeCar(){
        Vue.http.post(baseUrl + 'reservation/close', null, {
            headers: this.getAuthHeader()
        })
    },
    endReservation(successCallback, errorCallback){

        Vue.http.post(baseUrl + 'reservation/end', null, {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    getWallets(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'wallet', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    addPaymentMethodToWallet(body, successCallback, errorCallback){
        Vue.http.post(baseUrl + 'wallet/add_payment_method', body, {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, function (response) {
            errorCallback(response.data)
        })
    },
    getSubscriptions(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'client/subscriptions', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    myDriversList(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'drivers', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    addDriversToSubscription(body, successCallback, errorCallback){
        Vue.http.post(baseUrl + 'subscription/add_driver', body, {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    clientSubscriptions(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'client/subscriptions', {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    reservationDetail(reservationId, successCallback, errorCallback){
        Vue.http.get(baseUrl + 'reservation/' + reservationId, {
            headers: this.getAuthHeader()
        }).then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    driver(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'driver').then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    drivers(successCallback, errorCallback){
        Vue.http.get(baseUrl + 'drivers').then((response) => {
            successCallback(response.data)
        }, (response) => {
            errorCallback(response.data)
        })
    },
    serviceToc(successCallback, errorCallback){
        return Vue.http.get(baseUrl + 'config/service_toc').then(function (response) {
            successCallback(response.data)
        }, function (response) {
            errorCallback(response.data)
        })
    },
};

export default KeplerSdk



// WEBPACK FOOTER //
// ./src/keplerSdk.js